import { Component, OnInit,Input } from '@angular/core';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/common.service';
import { Router,ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { MatDialog } from '@angular/material';
import { PopupComponent } from '../../dialogs/popup/popup.component';
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
	public hoveredDate: NgbDate;
  public fromDate: NgbDate;
  @Input() modifyReservation: boolean = false; 
  public toDate: NgbDate;
  public navigationDate: NgbDate;
  public navigation: string = "arrows";
  public searchDateDisplayValue: string;
  public months:number = 2;
  public priceModuleData:any={};
  public hotelsData:any=[];
  public notAvailableRooms:any={};
  public cta_dates:any={};
  public minStay:any={};
  public ctd_dates:any={};
  public disabledDates: NgbDateStruct[]=[];
  private hotelsDataSubscription;
  private currentCalPos;
  public hotel_code = 'manhattantowerfl';
  public guest_count_adults:number = 2;
	public guest_count_child:number = 0;
	public showLoader:boolean = false;
	public showHotelDropDown:boolean = true;
	private modifyReservationData;
  public minDate:NgbDate;
  Adults = [
    {viewValue: 'Adults-1', value: 1},
    {viewValue: 'Adults-2', value: 2},
    {viewValue: 'Adults-3', value: 3},
    {viewValue: 'Adults-4', value: 4},
    {viewValue: 'Adults-5', value: 5},
    {viewValue: 'Adults-6', value: 6}
  ];
  kids = [
    {viewValue: 'Kids-0', value: 0},
    {viewValue: 'Kids-1', value: 1},
    {viewValue: 'Kids-2', value: 2},
    {viewValue: 'Kids-3', value: 3},
    {viewValue: 'Kids-4', value: 4}
   
  ];
  Rates = [  
    {value: 'Government', viewValue: 'Government'},
    {value: 'Vetern', viewValue: 'Vetern'},
    {value: 'AAA', viewValue: 'AAA'},
    {value: 'Senior', viewValue: 'Senior'},
    {value: 'Special Offer', viewValue: 'Special Offer'},
    {value: 'Group', viewValue: 'Group'}
  ];
    
	constructor(
    private router: Router,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private config: NgbDatepickerConfig,
    private commonService:CommonService,
    private activatedRoute:ActivatedRoute,
    public dialog: MatDialog
  ) {
		this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 2);
		var width = (window.innerWidth > 0) ? window.innerWidth :0 ;
		if(width <= 579){
			this.months =1;
		} else {
			this.months = 2;
		}
    this.minDate = calendar.getToday();
		if(this.router.url.split('/')[1] === 'hotel'){
			this.showHotelDropDown = false;
			this.hotel_code =this.router.url.split('/')[2];
		} else {
			this.showHotelDropDown = true;
		}
		this.hotelsDataSubscription = this.commonService.HotelsData.subscribe((hotelsData:any) => {
      if(hotelsData != '' && hotelsData[0] != undefined && hotelsData.length >0){
      	this.hotelsData = hotelsData;
      }
    });
    
	}

	ngAfterViewInit() {

  }

	ngOnInit() {
		const current = new Date();
		var newData = { year: current.getFullYear(), month:current.getMonth() + 1 };
		this.getMultiplePriceModule(newData);
		this.getStopSellCtaCtd(newData);
	}

	// Inline Date Picker
	onDateSelect(date: NgbDate) {
		var newdate =  moment(date.day+'/'+date.month+'/'+date.year).format('DD/MM/YYYY');
    if (!this.fromDate && !this.toDate) {
      if(Object.keys(this.cta_dates).length >0){
        if(this.cta_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm': false
            }
          );
        } else {
          this.fromDate = date;
        }
      } else {
        this.fromDate = date;
      }
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      if(Object.keys(this.cta_dates).length >0){
        if(this.ctd_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable.',
              'confirm': false
            }
          );
        } else {
          this.toDate = date;
        }
      } else {
        this.toDate = date;
      }
    } else {
      this.toDate = null;
      if(Object.keys(this.cta_dates).length >0){
        if(this.cta_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm':false
            }
          );
        } else {
          this.fromDate = date;
        }
      } else {
        this.fromDate = date;
      }
    }
    if(this.fromDate !== null && this.toDate !== null){
      if(this.notAvailableRooms.length>0){
        let fromDateRes = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
        fromDateRes = moment(fromDateRes).format('YYYY-MM-DD');
        let toDateRes = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
        toDateRes = moment(toDateRes).format('YYYY-MM-DD');
        let flag = true;
        this.notAvailableRooms.forEach((val,key)=>{
        	if(flag){
	          let  notAvailabeleDate = val.split('/');
	          let checkDate =  moment(notAvailabeleDate[2]+'-'+notAvailabeleDate[0]+'-'+notAvailabeleDate[1]).format('YYYY-MM-DD');

	          if(moment(checkDate).isBetween(fromDateRes, toDateRes)){
	            // this.fromDate = null;
	            // this.toDate = null;
	            flag = false;
	            this.openDialog(
                {
                  'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
                  'title':'Rooms unavialable',
                  'confirm':false
                }
              );
	          }	        		
        	}
        });
      }  
      let minStayDates = Object.keys(this.minStay);
      if(minStayDates.length>0){
        let fromDateRes = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
        let minStayDate =  this.fromDate.month + '/' + this.fromDate.day + '/' +this.fromDate.year ;
        fromDateRes = moment(fromDateRes).format('YYYY-MM-DD');
        let toDateRes = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
        toDateRes = moment(toDateRes).format('YYYY-MM-DD');
        let diff = moment(toDateRes).diff(moment(fromDateRes),'days');
        let flag =false;
        let newfromDate = '';
        minStayDates.forEach((id,nkey)=>{
          if(!flag){
            newfromDate = id;
            var datenumber = id.split('/');
            datenumber.forEach((val,key)=>{
              if(parseInt(val)< 10){
                datenumber[key] = (parseInt(val)%10).toString();
              }
            });
            id = datenumber.join('/');
            if(id == minStayDate){
              flag =true;
            }
          }
        });
        if(flag){
          if( diff < parseInt(this.minStay[newfromDate])){
            // this.fromDate = null;
            // this.toDate = null ;
            this.openDialog(
                {
                  'message':'You stay must include '+this.minStay[newfromDate]+' nights.',
                  'title':'Minimum length Required',
                  'confirm':false
                }
              );
          }
        }
        
      }  
    }
	}

	//Price Module Function
	getMultiplePriceModule(event){
		this.currentCalPos = event;
	    var currentDate = event.month+"/"+'01'+"/"+event.year;
	    var lastDate = moment(currentDate, "MM/DD/YYYY").add(1, 'M').endOf("month").format('YYYY-MM-DD');
	    currentDate = moment(currentDate).format('YYYY-MM-DD');
	    if(this.hotel_code != '' && this.hotel_code != undefined){
	    	var selectedHotel = this.hotel_code;
		    this.commonService.getMultiplePriceModule({'first':currentDate,'last': lastDate,'selectedHotel':selectedHotel}).then((data:any) => {
		      this.priceModuleData = data.data.amount;
		    });
	    }
	    
	}

	//Function to get Stopsell, CTA and CTD.


  getStopSellCtaCtd(event){
    var currentDate = event.month+"/"+'01'+"/"+event.year;
    let calendarView = document.querySelector('#full_calendar_datepicker');
      if (calendarView instanceof HTMLElement) { 
        let days = calendarView.getElementsByClassName('ngb-dp-day');
        for(let i = 0; i < days.length; i++) {
          // days[i].setAttribute('style','height:'+offsetHeight+' !important');
          days[i].classList.remove('disabled');  
          days[i].classList.remove('mls_days');
          // days[i].classList.add('no-pointer-events');  
        }
      }
      var lastDate = moment(currentDate, "MM/DD/YYYY").add(1, 'M').endOf("month").format('YYYY-MM-DD');
      currentDate = moment(currentDate).format('YYYY-MM-DD');
      if(this.hotel_code != '' && this.hotel_code != undefined ){
        var selectedHotel = this.hotel_code;
        this.commonService.getStopSellCtaCtd({'from':currentDate,'to': lastDate,'selectedHotel':selectedHotel}).then((data:any) => {
          let a = data.data.not_available_rooms;
          let cta_dates = data.data.cta_dates;
          let ctd_dates = data.data.ctd_dates;
          this.minStay = data.data.min_stay;
          let ctd_unique = ctd_dates.filter((item, i, ar) => ar.indexOf(item) === i);
          let cta_unique = cta_dates.filter((item, i, ar) => ar.indexOf(item) === i);
          let unique = a.filter((item, i, ar) => ar.indexOf(item) === i);
          this.cta_dates = cta_unique;
          this.ctd_dates = ctd_unique;
          this.notAvailableRooms = unique;
          if(this.notAvailableRooms.length>0){
            this.notAvailableRooms.forEach((id,nkey)=>{
              var datenumber = id.split('/');
              datenumber.forEach((val,key)=>{
                if(parseInt(val)< 10){
                  datenumber[key] = (parseInt(val)%10).toString();
                }
              });
                id = datenumber.join('/');
                var element = document.getElementById('full_calendar_'+id);
                if(element instanceof HTMLElement){
                  let parent = element.parentNode;
                  if(parent instanceof HTMLElement) {
                    parent.classList.add("disabled");
                  }
                }
            });
          }
          if(this.minStay && Object.keys(this.minStay).length>0 && this.fromDate !== null && this.toDate !== null){
            Object.keys(this.minStay).forEach((key)=>{
             if(parseInt(this.minStay[key])>1){
               var datenumber = key.split('/');
                datenumber.forEach((val,i)=>{
                  if(parseInt(val)< 10){
                    datenumber[i] = (parseInt(val)%10).toString();
                  }
                });
                let id = datenumber.join('/');
                if(this.fromDate !== null && this.toDate !== null){
                  let minStayfromDate =  this.fromDate.month + '/' + this.fromDate.day + '/' +this.fromDate.year ;
                  let minStaytoDate =  this.toDate.month + '/' + this.toDate.day + '/' +this.toDate.year ;
                  if(minStayfromDate === id || minStaytoDate === id){
                    // let days = document.querySelectorAll('.date-picker-set-div .ngb-dp-day .range');
                    // for(let i = 0; i < days.length; i++) {
                    //   days[i].classList.remove("range");
                    //   days[i].parentElement.tabIndex = -1;
                    //   let classes = days[i].classList;
                    //   if(classes.contains('faded')) {
                    //     days[i].classList.remove("faded");
                    //   }
                    // }
                  }
                  var element = document.getElementById('full_calendar_'+id);
                  if(element instanceof HTMLElement){
                    let parent = element.parentNode;
                    if(parent instanceof HTMLElement) {
                      parent.classList.add("mls_days");
                    }
                  }
                }
             }
            });
          }
          if(this.fromDate !== null && this.fromDate !== undefined){
            var room_stay_from = moment(this.fromDate.day+'/'+this.fromDate.month+'/'+this.fromDate.year).format('DD/MM/YYYY');
          }
          if(this.toDate !== null && this.toDate !== undefined){
            var room_stay_to = moment(this.toDate.day+'/'+this.toDate.month+'/'+this.toDate.year).format('DD/MM/YYYY');
          }
          if(this.notAvailableRooms.indexOf(room_stay_from) !== -1|| this.notAvailableRooms.indexOf(room_stay_to) !== -1){
            // this.fromDate = null;
            // this.toDate = null;
          }
        });
      }  
  }


	isDisabled = (date)=> {
    // var newdate =  moment(date.day+'/'+date.month+'/'+date.year).format('DD/MM/YYYY');
    // if(this.notAvailableRooms.length>0){
    //   if(this.notAvailableRooms.indexOf(newdate) !== -1 && this.fromDate !== null && this.toDate !== null){
    //     let checkDate =  moment(date.year+'-'+date.month+'-'+date.day).format('YYYY-MM-DD');
    //     if(moment(checkDate).isBetween(this.fromDate, this.toDate)){
          // this.fromDate = null;
          // this.toDate = null;
    //     }
    //     let calendar =document.querySelector('.simple-datepicker');
    //     let dayCell = calendar.querySelectorAll('.ngb-dp-day');
    //     dayCell.forEach((element,key)=>{
    //       if(element.querySelector('.disabled') !== null){
    //         element.classList.add("disabled");
    //       }
    //     });
    //     return true;
    //   } else if(this.notAvailableRooms.indexOf(newdate) !== -1 && (this.fromDate === null || this.toDate === null)){
    //     let calendar =document.querySelector('.simple-datepicker');
    //     let dayCell = calendar.querySelectorAll('.ngb-dp-day');
    //     dayCell.forEach((element,key)=>{
    //       if(element.querySelector('.disabled') !== null){
    //         element.classList.add("disabled");
    //       }
    //     });
    //     return true;
    //   }else {
    //     return false;
    //   }
    // } else {
    //     return false;
    // }
    return false;
  }
	resetCalendar(){
		this.getMultiplePriceModule(this.currentCalPos);
		this.getStopSellCtaCtd(this.currentCalPos);
	}

	navigateCalendar(event){
		this.getMultiplePriceModule(event);
		this.getStopSellCtaCtd(event);
	}

	isHovered(date: NgbDate) {
	    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
	}

	isInside(date: NgbDate) {
	    return date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
	    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
	}


	search(){
		if(this.hotel_code !== undefined && this.hotel_code !== null && this.hotel_code !=='' && this.toDate !== undefined  && this.fromDate !== undefined  && this.fromDate !== null && this.toDate !== null  ){
				var room_stay_from = moment(this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day).format('YYYY-MM-DD');
				var room_stay_to = moment(this.toDate.year+'-'+this.toDate.month+'-'+this.toDate.day).format('YYYY-MM-DD');
        if(moment(room_stay_to).diff(moment(room_stay_from),'days')<0){
           this.openDialog(
              {
                'message':'Depature date must be greater than arrival Date.',
                'title':'Invalid Dates',
                'confirm':false
              }
            );
           return;
        }
        if( room_stay_from ==='Invalid date' || room_stay_to === 'Invalid date'){
          this.openDialog({
              'message':'Please select a valid date range.',
              'title':'Invalid dates',
              'confirm': false
            });
            return;
        }
        let newfromDate =moment(this.toDate.month+'/'+this.toDate.day+'/'+this.toDate.year).format('MM/DD/YYYY');
        if(this.minStay[newfromDate] !== null && this.minStay[newfromDate] !== undefined && this.minStay[newfromDate] !== ''){

          if(moment(room_stay_to).diff(moment(room_stay_from),'days') < parseInt(this.minStay[newfromDate])){
            this.openDialog({
              'message':'You stay must include '+this.minStay[newfromDate]+' nights.',
              'title':'Minimum length Required',
              'confirm':false
            });
            return;
          }

        }
        var adults = this.guest_count_adults;
		    var child = this.guest_count_child;
        this.showLoader= true;
        // SHow loader if calendar search from same page
        if(this.router.url.indexOf('search-results') !== -1) {
          this.commonService.showCommonLoader.next(true);
        }
        var room_stay_from_new = moment(this.fromDate.month+'-'+this.fromDate.day+'-'+this.fromDate.year).format('MM-DD-YYYY');
        var room_stay_to_new = moment(this.toDate.month+'-'+this.toDate.day+'-'+this.toDate.year).format('MM-DD-YYYY');
		    this.router.navigate(['/search-results/'+this.hotel_code+'/'+room_stay_from_new+'/'+room_stay_to_new+'/'+adults+"/"+child]);
		    this.commonService.updatecalendarSearchStatus(true);
		    this.showLoader= false;
		    // if(this.router.url.split('/')[1] === 'search-results'){
		    // 	 window.location.reload();
		    // }
		} else if(this.toDate === undefined  || this.fromDate === undefined  || this.fromDate === null || this.toDate === null ) {
       this.openDialog(
        {
          'message':'Please select arrival and departure dates for stay.',
          'title':'Invalid Dates',
          'confirm':false
        }
      );
		}
	}
  
  /**************************
  *To Show Error  dialog box*
  **************************/
  openDialog(data): void {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '600px',
      data: data,
       panelClass: 'mlspopblock'
    });

    dialogRef.afterClosed().subscribe(res => {
      
    });
  }
}
